import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Icon } from '../common/Icons';
import Wrapper from '../common/Wrapper/Wrapper';
import { StyledSearch, StyledInput } from './SearchBar.styles';

function SearchBar({ searchQuery, info }) {
  const [searchTerm, setSearchTerm] = useState('');

  const sendData = () => {
    searchQuery(searchTerm);
  };

  const onChange = event => {
    setSearchTerm(event.target.value);
  };

  useEffect(() => {
    sendData();
  }, [searchTerm]);

  return (
    <Wrapper>
      <StyledSearch>
        <StyledInput
          type="text"
          value={searchTerm}
          onChange={onChange}
          placeholder="Search_"
          spellCheck="false"
          info={info}
        />
        <Icon.Search aria-hidden />
      </StyledSearch>
    </Wrapper>
  );
}

SearchBar.propTypes = {
  searchQuery: PropTypes.func,
  info: PropTypes.bool,
};

SearchBar.defaultProps = {
  info: false,
};

export default SearchBar;
